import React, { useEffect } from 'react';
import { AccordionBodyItem, AccordionHeaderTitle } from 'component/Accordion';

import {
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { InputComponent } from 'component/Input';
import { InternalHazardArea } from './GeneralInfo/InternalHazardArea';
import { IMSMAID } from './GeneralInfo/IMSMAID';
import { IMSMASwither } from './GeneralInfo/IMSMASwither';
import { HazardName } from './GeneralInfo/HazardName';
import { ReportDate } from './GeneralInfo/ReportDate';
import { ReportingOrganization } from './GeneralInfo/ReportingOrganization';
import { ReportProvider } from './GeneralInfo/ReportProvider';
import { CommandId } from './GeneralInfo/CommandId';
import { ReporterPosition } from './GeneralInfo/Position';
import { DateOfHA } from './GeneralInfo/DateOfHA';
import { AreaType } from './GeneralInfo/AreaType';
import { HazardType } from './GeneralInfo/HazardType';
import { Donor } from './GeneralInfo/Donor';
import { TaskCustomer } from './GeneralInfo/TaskCustomer';
import { ReportTypeInfo } from './GeneralInfo/ReportTypeInfo';
import { ReportZone } from './GeneralInfo/ReportZone';
import { AsyncSelectComponent, SelectComponent } from 'component/Select';
import { getImsmaHaRecords } from 'api/HaApi';

export const GeneralInfo = (props) => {
  const handleInput = (value) => {
    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        general: {
          ...prevFormData.info.general,
          hazard_name: value,
        },
      },
    }));
  };

  useEffect(() => {
    if (props?.formData?.info?.general?.from_existing_ha_report === false) {
      props.setFormData((prevFormData) => ({
        ...prevFormData,
        info: {
          ...prevFormData?.info,
          general: {
            ...prevFormData?.info?.general,
            ha_imsma_id: null,
          },
        },
      }));
    }
  }, [props?.formData?.info?.general?.from_existing_ha_report]);

  const isExistingReport = props.formData?.info?.general?.from_existing_ha_report === true;

  const loadHaReportOptions = async (inputValue) => {
    try {
      const response = await getImsmaHaRecords({
        imsmaId: inputValue,
      });
      const rows = response?.data?.results ?? response?.data?.items ?? response?.data ?? [];
      const uniqueIds = [...new Set(rows
        .map((report) =>
          report?.imsma_id ??
          report?.imsmaId ??
          report?.info?.general?.imsma_id ??
          report?.properties?.imsma_id)
        .filter(Boolean))];
      return uniqueIds.map((id) => ({
        value: id,
        label: id,
      }));
    } catch (error) {
      console.error('Error fetching HA reports:', error);
      return [];
    }
  };

  return (
    <>
      <AccordionItemHeading>
        <AccordionItemButton>
          <AccordionHeaderTitle
            accordionId="1"
            validationForm={props.validationForm}
            block="general"
            titleUA={
              <div className="flex-group">
                <span>Загальна інформація</span>
                <span className="star">*</span>
              </div>
            }
            titleEN="General Information"
          />
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        {!props?.formData?.report_sent_to_imsma &&
          (props?.mode === 'create' || props?.formType === 'ha') && (
            <ReportTypeInfo
              formData={props?.formData}
              setFormData={props?.setFormData}
              mode={props?.mode}
            />
          )}

        {isExistingReport && (
          <AccordionBodyItem
            accordionSubId={<div></div>}
            titleUA={
              <div
                className={`${!props?.formData?.info?.general?.ha_imsma_id && isExistingReport ? 'error-text' : ''}`}
              >
                Оберіть ІЗТ/ЗТ для оновлення
                {!props?.formData?.info?.general?.ha_imsma_id && isExistingReport && (
                  <span className="star">*</span>
                )}
              </div>
            }
            titleEN={
              <div
                className={`${!props?.formData?.info?.general?.ha_imsma_id && isExistingReport ? 'error-text' : ''}`}
              >
                Select the SHA/CHA to update
                {!props?.formData?.info?.general?.ha_imsma_id && isExistingReport && (
                  <span className="star">*</span>
                )}
              </div>
            }
            children={
              <div className="flex-column-group align-right">
                <AsyncSelectComponent
                  promiseOptions={loadHaReportOptions}
                  value={
                    props?.formData?.info?.general?.ha_imsma_id
                      ? {
                          value: props?.formData?.info?.general?.ha_imsma_id,
                          label: props?.formData?.info?.general?.ha_imsma_id,
                        }
                      : null
                  }
                  handleSelect={(selectedValue) => {
                    props.setFormData((prevFormData) => ({
                      ...prevFormData,
                      info: {
                        ...prevFormData?.info,
                        general: {
                          ...prevFormData?.info?.general,
                          ha_imsma_id: selectedValue,
                        },
                      },
                    }));
                  }}
                  placeholder="Select ID I3T / 3T"
                  className={
                    !props?.formData?.info?.general?.ha_imsma_id && isExistingReport
                      ? 'error-border'
                      : ''
                  }
                />
              </div>
            }
          />
        )}
        <InternalHazardArea
          formType={props?.formType}
          formData={props?.formData}
          setFormData={props?.setFormData}
        />

        <IMSMAID formType={props?.formType} formData={props?.formData} />

        <IMSMASwither
          formType={props?.formType}
          formData={props?.formData}
          setFormData={props?.setFormData}
        />
        {props.formType !== 'ha' ? (
          <AccordionBodyItem
            titleUA="Назва"
            titleEN="Name"
            className={props?.errors?.general?.hazard_name ? 'error' : ''}
            children={
              <InputComponent
                value={props?.formData?.info?.general?.hazard_name}
                name="hazard_name"
                id="hazard_name"
                handleInput={handleInput}
                blueLink
                limitChar
              />
            }
          />
        ) : (
          ''
        )}
        <HazardName
          formType={props?.formType}
          formData={props?.formData}
          setFormData={props?.setFormData}
          errors={props?.errors}
        />

        <ReportDate
          formType={props?.formType}
          formData={props?.formData}
          setFormData={props?.setFormData}
          errors={props?.errors}
        />

        <ReportingOrganization
          formType={props?.formType}
          formData={props?.formData}
          setFormData={props?.setFormData}
        />

        <ReportProvider formType={props?.formType} formData={props?.formData} />

        <CommandId
          formType={props?.formType}
          formData={props?.formData}
          setFormData={props?.setFormData}
        />

        <ReporterPosition formType={props?.formType} formData={props?.formData} />

        <DateOfHA
          formType={props?.formType}
          formData={props?.formData}
          setFormData={props?.setFormData}
          errors={props?.errors}
        />

        <AreaType
          formType={props?.formType}
          formData={props?.formData}
          setFormData={props?.setFormData}
          map={props?.map1}
        />

        <HazardType
          formType={props?.formType}
          formData={props?.formData}
          setFormData={props?.setFormData}
        />

        <Donor
          formType={props?.formType}
          formData={props?.formData}
          setFormData={props?.setFormData}
        />
        <TaskCustomer
          formType={props?.formType}
          formData={props?.formData}
          setFormData={props?.setFormData}
          errors={props?.errors}
        />
        <ReportZone formData={props?.formData} />
      </AccordionItemPanel>
    </>
  );
};
